<template>
  <div :class="[`x3-29`, className || ``]">
    <div class="ellipse-170-6"></div>
    <div class="x1-83 poppins-normal-white-40px-2">{{ x1 }}</div>
    <img
      class="line-46-6"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-46-6.svg"
      alt="Line 46"
    />
  </div>
</template>

<script>
export default {
  name: "X392",
  props: ["x1", "className"],
};
</script>

<style>
.x3-29 {
  height: 60px;
  left: 390px;
  position: absolute;
  top: 1px;
  width: 112px;
}

.ellipse-170-6 {
  aspect-ratio: 1;
  background-color: var(--shiraz);
  border-radius: 30px;
  height: 60px;
  left: 50px;
  position: absolute;
  top: 0;
  width: 60px;
}

.x1-83 {
  left: 67px;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.line-46-6 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 29px;
  width: 50px;
}

.x3-29.x2-33,
.x3-29.x2-35 {
  left: 280px;
}

.x3-29.x3-30,
.x3-29.x3-32 {
  left: 170px;
}

.x3-29.x3-30 .x1-83,
.x3-29.x2-34 .x1-83,
.x3-29.x3-32 .x1-83,
.x3-29.x2-36 .x1-83 {
  left: 68px;
}

.x3-29.x2-34,
.x3-29.x2-36 {
  left: 60px;
}
</style>
